export default {
    sm: '640px',
    md: '768px',
    lg_1: '910px',
    lg: '1024px',
    xl: '1200px',
    xxl: '1440px',
    xxxl: '1560px',
    xxxl_1: '2500px',
    md_const: 768
}
